import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'hmb-noshop',
  templateUrl: './noshop.component.html'
})

export class NoShopComponent {
 
  constructor( private router: Router) {

  }

}

